import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface MobilePageHeaderProps {
  title: string;
  onBack?: () => void;
  backPath?: string;
  className?: string;
}

const MobilePageHeader: React.FC<MobilePageHeaderProps> = ({ 
  title, 
  onBack, 
  backPath, 
  className = '' 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backPath) {
      navigate(backPath);
    }
  };

  return (
    <div className={`sticky top-0 z-50 backdrop-blur-xl bg-black/80 border-b border-white/10 md:hidden ${className}`}>
      <div className="flex items-center justify-between px-4 py-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleBack}
          className="text-white hover:bg-white/10 p-2"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-sm font-medium text-white uppercase tracking-wide">
          {title}
        </h1>
        <div className="w-8" />
      </div>
    </div>
  );
};

export default MobilePageHeader;
